export const extractGroupsAndVariablesIds = (
    text: string
) => {
    const regex =
        /<variable class="cdx-inline-tool-variable" data-group-id="([0-9, A-z, -]*)" data-variable-id="([0-9, A-z, -]*)">((?!variable).)*<\/variable>/g;

    const result = text.matchAll(regex);

    const variablesIds = []
    const groupsIds = []

    for (const matches of result) {
        variablesIds.push(matches[2])
        groupsIds.push(matches[1])
    }
    return {variablesIds,groupsIds}
};

export const getConditionalGroupsAndVariablesIds = (
    data: any
) => {
    const conditionalVariablesIds = []
    const conditionalGroupsIds = []

    for (const condition of data.conditions) {
        conditionalVariablesIds.push(condition.variableId)
        conditionalGroupsIds.push(condition.groupId)
    }
    return {conditionalVariablesIds,conditionalGroupsIds}
};
